import { Injectable } from '@angular/core';
import * as mixpanel from 'mixpanel-browser';
import { ConfigService } from '../core/config.service';
import { AuthService } from '../core/auth.service';

// enable for debugging, set to false for production
const ENABLE_DEBUG = false;

@Injectable()
export class MixpanelService {
  constructor(private config: ConfigService, private auth: AuthService) {}

  private mixpanelToken = this.config.getConfig('mixpanelToken');

  /**
   * Initialize mixpanel.
   *
   * @param {string} userToken
   * @memberof MixpanelService
   */
  init(): void {
    if (!this.mixpanelToken) {
      console.log('No Mixpanel token found, did not initialise');
    }
    if (this.mixpanelToken) {
      mixpanel.init(this.mixpanelToken, { debug: ENABLE_DEBUG });
      // console.log(`Mixpanel init with ${this.mixpanelToken}`);
      // if user is opted out, try and opt them in
      if (mixpanel.has_opted_out_tracking()) {
        console.log(`User has opted out of tracking. Events will not be tracked.`);
      }
    }
  }

  /**
   * Identify user
   *
   * @memberof MixpanelService
   */
  async identify() {
    if (!this.mixpanelToken) {
      console.log('No Mixpanel token found, did not identify');
      return;
    }
    const cognitoId = this.auth.getCognitoIdFromToken();
    const customerName = await this.auth.getCustomerNameP();
    const email = this.auth.getEmailFromToken();
    const userDetails = {
      $email: email,
      $name: customerName,
      isAdmin: this.auth.isAdmin(), // SensorFlow Admin
      isRegularUser: this.auth.isNormalUser(), // only true if user is in 1 group that is is "Users", not also "Client_Admin", etc
      isClientAdmin: this.auth.isClientAdmin(),
    };

    if (ENABLE_DEBUG) {
      console.log(`identify user with Cognito ID ${cognitoId} and the following details`);
      console.table(userDetails);
    }
    // identify with unique ID
    mixpanel.identify(cognitoId);
    // set user details
    mixpanel.people.set(userDetails);
  }

  /**
   * Push new action to mixpanel.
   *
   * @param {string} id Name of the action to track.
   * @param {*} [action={}] Actions object with custom properties.
   * @memberof MixpanelService
   */
  track(id: string, action: object = {}): void {
    action = this.addWidthHeightToAction(action);
    if (!this.mixpanelToken) {
      console.log('No Mixpanel token found, did not track');
      return;
    }
    mixpanel.track(id, action);
  }

  addWidthHeightToAction(actions: any = {}) {
    actions.ViewportHeight = document.documentElement.clientHeight;
    actions.ViewportWidth = document.documentElement.clientWidth;
    return actions;
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/shared/mixpanel.service.ts